module.exports = __webpack_public_path__ + "static/media/header_background_1.acf705be.jpg";